import { Dialog, Slide } from '@mui/material';
import React, { FC } from 'react';

import { Props } from '../../@types';
import { TransitionProps } from '@mui/material/transitions';
import { getDirection } from '@/lang/utils';
import { pxToRem } from '@/theme/typography';
import shallow from 'zustand/shallow';
import { useDialog } from '@/logic/state/dialog';
import { useRouter } from 'next/router';

// TODO: apply transition to this component without causing freezing issue

export const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction={'left'} in ref={ref} {...props} />;
});

export const MainDialog: FC<Props> = ({ children }) => {
  const dialog = useDialog(s => s.dialog, shallow);

  const { locale } = useRouter();
  const dir = getDirection(locale);
  return (
    dialog?.wrapper && (
      <Dialog
        open={dialog?.wrapper ?? false}
        TransitionComponent={Transition}
        dir={dir}
        PaperProps={{
          sx: {
            minHeight: {
              tablet: dialog?.tabletMinHeight || pxToRem(680),
            },
            ...dialog?.minWidth,
          },
        }}
      >
        {children}
      </Dialog>
    )
  );
};
